export default __webpack_public_path__ + "static/media/Royal Dragon Elite Belt.c31c128c.jpg";